module.exports = __webpack_public_path__ + "img/lianhuashan.5380aaab.png";